import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';

export function getRedirectUrl(props) {
  const isExpired =
    props.user.config &&
    props.user.config.exportTrialEnd && 
    moment(props.user.config.exportTrialEnd).diff(moment()) < 0;

  if (
    props.user.config &&
    props.user.config.exportEnabled &&
    !isExpired
  ) {
    return '/report';
  }
}

export default function (ComposedComponent) {
  class RequirePremiumOff extends Component {
    static contextTypes = {
      router: PropTypes.object,
    };

    redirect(to) {
      global.window && window.location && window.location.replace(to + window.location.search);
    }

    render() {
      if (this.props.isLoading) {
        return <div></div>;
      }

      const redirectUrl = getRedirectUrl(this.props);
      if (redirectUrl) {
        this.redirect(redirectUrl);
        return null;
      }

      return <ComposedComponent {...this.props} />;
    }
  }

  function mapStateToProps(state) {    
    return {
      isLoading: state.auth.isLoading,
      user: state.auth.user,
    };
  }

  return connect(mapStateToProps)(RequirePremiumOff);
}
